import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import AvgBarChartTemplate from "views/molecules/charts/template/AvgBarChartTemplate"

const translationPrefix = "score:score.7.chart6"
const DC_CLOUD_TYPES = [
  "data_center_internal_inventories",
  "data_center_external_inventories",
  "data_center_cloud_inventories",
]

const REFERENCE_PUE = [2, 1.6, 1.2] // we put 1.6 and not 1.58 because in the database we don't have enough precision

const ChartOdd7Pue = ({ pueScores }) => {
  const { t } = useTranslation()
  const labels = DC_CLOUD_TYPES.map((cloudType) =>
    t(`${translationPrefix}.${cloudType}`)
  )
  const data = DC_CLOUD_TYPES.map((cloudType) => pueScores[cloudType]?.average)

  return (
    <AvgBarChartTemplate
      title={t(translationPrefix + ".title")}
      data={data}
      dataBarTitle={t("score:score.common.datasets.client_data")}
      referenceData={REFERENCE_PUE}
      labelKeys={labels}
      helpText={t(translationPrefix + ".help")}
      shouldRound={false}
    />
  )
}

ChartOdd7Pue.propTypes = {
  pueScores: PropTypes.objectOf(
    PropTypes.shape({
      average: PropTypes.string,
      coverage: PropTypes.number.isRequired,
    })
  ).isRequired,
}

export default ChartOdd7Pue
